import { SearchResultsListingsGridQueryVariables } from '../../contexts/search-results-context/query/__generated__/search-results-listings.fed.query'
import { useHistory } from 'react-router-dom'
import { useRetailerStockSearch } from '../../utils/retailer-stock'
import { useQueryFilters } from '../search-context/use-query-filters'
import { useQuerySortBy } from '../search-context/use-query-sort-by'
import { ListingType } from '../../__generated__/fed-graphql-types'
import { useChannel } from '../use-abtest.hook'
import { useEffect, useState } from 'react'
import { SessionKeys } from '../../utils/session-keys'
import { uuidProvider } from '../../pages/search-results/uuid-provider'

export const useListingsQueryVariables = (): SearchResultsListingsGridQueryVariables => {
    const {
        location: { search },
    } = useHistory()
    const [searchId, setSearchId] = useState('')
    const [isRetailerStockSearch] = useRetailerStockSearch()
    const filters = useQueryFilters()
    const sortBy = useQuerySortBy()
    const [page, setPage] = useState(1)

    useEffect(() => {
        const queryParams = new URLSearchParams(search)
        const pageValue = Math.abs(Number(queryParams.get('page'))) || 1
        setPage(pageValue)
        setSearchId(sessionStorage.getItem(SessionKeys.SEARCH_ID) ?? uuidProvider.getUUID())
    }, [search])

    const channel = useChannel()

    return {
        filters,
        channel,
        page,
        sortBy,
        listingType: isRetailerStockSearch ? [ListingType.NATURAL_LISTING] : null,
        searchId,
        useGridLayout: true,
    }
}
